export default __webpack_public_path__ + "locales/ru/SharingPanel.json?hash=4a11494c32cc3bb0c560d80f4f3d8253";